module.exports = {
      id: "calendar-usage",
      viewBox: "0 0 17.552 17.301",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#calendar",
      toString: function () {
        return this.url;
      }
    }